import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if(event.body.statusCode){
                if ((event.body.statusCode.toString().startsWith("2"))){
                  return event;
                }
                throw (new HttpErrorResponse({
                  "error":{"errorMessage":event.body.errorMessage},
                  "status":event.body.statusCode
                }));
              }else{
                return event;
              }
            }
            return event;
        }));
    }
}
